import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { BUSINESS_DATA_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getBusinessDataAction = createAsyncThunk(
    'store/getBusinessDataAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ BUSINESS_DATA_PATH }?podId=${ data.podId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getBusinessDataSlice = createSlice({
    name: 'getBusinessDataSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getBusinessDataAction.pending, () => STATE__API__STARTED);
        builder.addCase(getBusinessDataAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getBusinessDataAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getBusinessDataState = (state) => state.store.getBusinessData;
export default getBusinessDataSlice.reducer;
